module.exports = __webpack_public_path__ + "static/media/MatchFormats.25cec49a.svg";